import * as React from 'react';
import getDisplayName from 'recompose/getDisplayName';

import { PageConsumer } from 'ha/modules/Page/contexts/PageContext';

export interface PageNameProps {
  pageName: string;
  pageCategory?: string;
}

export default function withCurrentPageName<P extends PageNameProps>(
  ComponentToWrap: React.ComponentType<P>,
) {
  const WithCurrentPageName: React.SFC<
    Omit<P, keyof PageNameProps>
  > = props => (
    <PageConsumer>
      {({ name, category }) => (
        <ComponentToWrap
          pageName={name}
          pageCategory={category}
          {...(props as P)}
        />
      )}
    </PageConsumer>
  );

  WithCurrentPageName.displayName = `withCurrentPageName(${getDisplayName(
    ComponentToWrap,
  )})`;

  return WithCurrentPageName;
}
